// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyA6uZXWUtolqhxSaSJZXVWlx5MqxQfVqiY",
  authDomain: "prettylovecolombo-f644d.firebaseapp.com",
  projectId: "prettylovecolombo-f644d",
  storageBucket: "prettylovecolombo-f644d.firebasestorage.app",
  messagingSenderId: "481316830707",
  appId: "1:481316830707:web:060e6a9696d1c70a88a686",
  measurementId: "G-Z8R1CFEJTY"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
